/* eslint-disable */
import api from './api';
import { CPB_URL } from './servers';

export const fetchMonitoreos = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getMonitoreos`, data);

export const validarHallazgosByMoni = async (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);

export const fetchMuestrasByIdMonitoreo = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosHallazgo`, data);

export const fetchImagenesByIdFormato = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosFormato`, data);

export const fetchImagenesByIdVisita = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosVisita`, data);

export const editarMedioImp = async (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);

export const fetchMonitoreosInternet = async () => {
  const data = { tipoMonitoreo: 3 };
  return api.post(`${CPB_URL}/monitoreos/getMonitoreos`, data);
};
export const crearMedioImp = async (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);

export const sincronizarTodosMonitoreos = async (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);

export const getImagenesVisitas = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosVisita`, data);

export const imagenesHallazgo = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosHallazgo`, data);

export const imagenesMonitoreosInternet = async (data) =>
  api.post(`${CPB_URL}/monitoreos/getArchivosMonitoreo`, data);

export const editarMonitoreo = async (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarTodosMonitoreos`, data);

export const sincronizarFilesParts = async (data) =>
  api.post(`${CPB_URL}/monitoreos/sincronizarArchivoPartes`, data);

// MNI - Llamado a generación de PDF Monitoreos
export const generarPDFMonitoreos = async (data) =>
  api.post(`${CPB_URL}/monitoreos/generarPDFMonitoreos`, data);

export const generarPDFMonitoreosValidacion = async (data) =>
  api.post(`${CPB_URL}/monitoreos/validarPDFMonitoreos`, data);